import styled from '@emotion/styled';
import { motion } from 'framer-motion';
import { semantic_colors } from '../../foundation';

export const DatePickerMask = styled(motion.div)<{ position: 'top' | 'bottom' }>`
  position: absolute;
  height: 40px;
  width: calc(100% - 32px);
  left: 16px;
  pointer-events: none;
  z-index: 2;
  background: linear-gradient(
    ${({ position }) => (position === 'top' ? '0deg' : '180deg')},
    rgba(255, 255, 255, 0) 0%,
    ${semantic_colors.background.surface} 100%
  );
`;
